export default __webpack_public_path__ + "static/media/userqn_event.392d41c5.svg";